import SuggestStructure from "../../Constants/SuggestStructure"; // Import structure

export const fetchSuggestedData = async () => {
  try {
    const response = await fetch("/api/mock/AccountPage/UserAccountSuggestContentMockapi.json"); // Fetch from public folder
    const data = await response.json();

    // Format data according to SuggestStructure
    const formattedData = data.map((user) => ({
      userId: user.userId || "",
      useruuid: user.useruuid || "",
      userName: user.userName || "",
      userimage: user.userimage || "",
      profileId: user.profileId || "",
      posts: (user.posts || []).map((post) => ({
        postId: post.postId || "",
        descriptions: post.descriptions || "",
        timestamp: post.timestamp || "",
        location: post.location || "",
        sharedBy: post.sharedBy || "",
        medias: (post.medias || []).map((media) => ({
          mediatype: media.mediatype || "",
          mediaurl: media.mediaurl || "",
        })),
      })),
    }));

    return formattedData;
  } catch (error) {
    console.error("Error fetching suggested data:", error);
    return [];
  }
};
